import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { loaderInterceptor } from './core/interceptors/loader.interceptor';
import { ModalModule } from 'ngx-bootstrap/modal';
import { authInterceptor } from './core/interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    importProvidersFrom(
      HttpClientModule,
      BrowserAnimationsModule,
      ToastrModule.forRoot({
        positionClass: 'toast-top-center',
        timeOut: 3000,
        preventDuplicates: true,
        progressBar: false
      }),
      ModalModule.forRoot(),
    ),
    provideHttpClient(
      withInterceptors([authInterceptor, loaderInterceptor])
    ),
    CommonModule
  ]
};
